import React, { useState } from "react";
import AchievementsHeader from "../components/ui/achievements/achievements-header";
import UserProfileCard from "../components/ui/achievements/user-profile-card";
import XpProgress from "../components/ui/achievements/xp-progress";
import AchievementStats from "../components/ui/achievements/achievement-stats";
import { Sidebar } from "../components/ui/sidebar";
import AchievementsGrid from "../components/ui/achievements/achievements-grid";
import Leaderboard from "../components/ui/achievements/leaderboard";
import { UniversalSearch } from "../components/ui/universal-search";
import {AIChatBox} from "../components/ui/ai-chat-box";
import ProtectedRoute from '../components/ProtectedRoute';


export default function AchievementsPage() {
  const [achievements] = useState([
    {
      id: "1",
      name: "Bookworm",
      description: "Read 10 books",
      icon: "BookOpen",
      isUnlocked: true,
      unlockedDate: "Nov 15, 2024",
    },
    {
      id: "2",
      name: "Rising Star",
      description: "Top 10 rank",
      icon: "Star",
      isUnlocked: true,
      unlockedDate: "Nov 10, 2024",
    },
    {
      id: "3",
      name: "Math Whiz",
      description: "Solve 50 puzzles",
      icon: "Calculator",
      isUnlocked: false,
    },
    {
      id: "4",
      name: "Perfect Week",
      description: "7-day streak",
      icon: "Flame",
      isUnlocked: false,
    },
    {
      id: "5",
      name: "Team Player",
      description: "Join a study group",
      icon: "Users",
      isUnlocked: false,
    },
  ]);

  const [leaderboard] = useState([
    {
      rank: 1,
      name: "Alex Johnson",
      points: 15200,
      avatar: "https://lh3.googleusercontent.com/aida-public/AB6AXuA9VFBR...",
    },
    {
      rank: 2,
      name: "Maria Garcia",
      points: 13150,
      avatar: "https://lh3.googleusercontent.com/aida-public/AB6AXuAS_Yf...",
    },
    {
      rank: 3,
      name: "Sarah Lee",
      points: 12450,
      avatar: "https://lh3.googleusercontent.com/aida-public/AB6AXuC7LnI...",
      isCurrentUser: true,
    },
    {
      rank: 4,
      name: "David Chen",
      points: 11900,
      avatar: "https://lh3.googleusercontent.com/aida-public/AB6AXuBEi44...",
    },
    {
      rank: 5,
      name: "Emily Rose",
      points: 10500,
      avatar: "https://lh3.googleusercontent.com/aida-public/AB6AXuAYgx6...",
    },
  ]);

  const handleSearch = (query) => {
    console.log("Universal search for:", query);
  };

  const totalPoints = 12450;
  const classRank = 3;
  const currentStreak = 12;
  const currentXp = 2500;
  const maxXp = 3000;

  return (
    <ProtectedRoute>
      <div className="flex min-h-screen bg-slate-200">
      {/* Sidebar (self-contained) */}
      <Sidebar />

      <AIChatBox />

      {/* Universal Search Component */}
      <UniversalSearch onSearch={handleSearch} />

      {/* Main Content */}
      <main className="flex-1 lg:ml-64 p-3 sm:p-4 md:p-6 lg:p-8 overflow-y-auto">
        {/* Mobile Header with Menu Button */}
        <div className="md:hidden flex items-center gap-3 mb-4 pb-4 border-b border-slate-200">
          <button
            className="p-2 rounded-lg bg-slate-100 hover:bg-slate-200 transition-colors min-h-[44px] min-w-[44px] flex items-center justify-center"
            aria-label="Toggle menu"
            onClick={() =>
              document.dispatchEvent(new CustomEvent("toggle-sidebar"))
            }
          >
            <svg
              className="w-6 h-6 text-slate-700"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 6h16M4 12h16M4 18h16"
              />
            </svg>
          </button>
          <div className="flex-1">
            <h1 className="text-lg font-bold text-slate-900">Achievements</h1>
            <p className="text-sm text-slate-600">Track your progress</p>
          </div>
        </div>

        {/* Page Content */}
        <div className="max-w-6xl mx-auto space-y-4 sm:space-y-6 md:space-y-8">
          {/* Desktop Header */}
          <div className="hidden md:block">
            <AchievementsHeader />
          </div>

          {/* User Profile Card */}
          <div className="overflow-x-auto">
            <UserProfileCard
              level={5}
              levelName="Explorer"
              userName="Sarah"
              rank={classRank}
              totalStudents={28}
              avatar="https://lh3.googleusercontent.com/aida-public/AB6AXuA_M39hiJwQrfpDxL9LKaueZWH5RYEVx8_c_bII9b79_7Y6fBOwkViMXTctfj_gYdl-HhEak_KBmZAhCv7sd4hvpb95SRSwhTO1IFNqVspmnRZHFycAyWxkGpa_oFnQ2Xl8M8nnqxg3vB6Lkk3zi666UWasN_vfa_7VsUdqBm3rpMcVNDzyqC9a5QHHDTkx0b5BXDMhQOPpOHxYTlQ4tsaRcQL64a7_4HMnk0VnIXwaR2EBIkDy0W5nfhrjsORGhrYnSyKbje52To0"
            />
          </div>

          {/* XP Progress */}
          <XpProgress current={currentXp} max={maxXp} />

          {/* Achievement Stats */}
          <div className="overflow-x-auto">
            <AchievementStats
              totalPoints={totalPoints}
              classRank={classRank}
              totalStudents={28}
              currentStreak={currentStreak}
            />
          </div>

          {/* Achievements Grid */}
          <AchievementsGrid achievements={achievements} />

          {/* Leaderboard */}
          <div className="overflow-x-auto">
            <Leaderboard entries={leaderboard} />
          </div>
        </div>
      </main>
    </div>
    </ProtectedRoute>
  );
}